import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { useFlowWebContext } from './useFlowWebContext';
export function withFlowWebContext(Component) {
  return function (props) {
    var configContext = useFlowWebContext();
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      flowWebConfig: configContext
    }));
  };
}